import { useMemo } from 'react';

export const usePagination = (activePage: number, totalPageCount: number) => {
  const switchToCorrectPaginationArr = () => {
    switch (true) {
      case activePage === 1:
        return [
          { value: activePage, id: 't1' },
          { value: activePage + 1, id: 't2' },
          { value: '...', id: 't3', jumpNext: true },
          { value: totalPageCount - 1, id: 't4' },
          { value: totalPageCount, id: 't5' },
        ];
      case activePage === 2:
        return [
          { value: activePage - 1, id: 't1' },
          { value: activePage, id: 't2' },
          { value: activePage + 1, id: 't3' },
          { value: '...', id: 't4', jumpNext: true },
          { value: totalPageCount, id: 't5' },
        ];
      case activePage >= 3 && activePage < totalPageCount - 1:
        return [
          { value: '...', id: 't1', jumpNext: false },
          { value: activePage - 1, id: 't2' },
          { value: activePage, id: 't3' },
          { value: activePage + 1, id: 't4' },
          { value: '...', id: 't5', jumpNext: true },
        ];

      case activePage === totalPageCount - 1:
        return [
          { value: 1, id: 't1' },
          { value: '...', id: 't2', jumpNext: false },
          { value: activePage - 1, id: 't3' },
          { value: activePage, id: 't4' },
          { value: activePage + 1, id: 't5' },
        ];
      case activePage === totalPageCount:
        return [
          { value: 1, id: 't1' },
          { value: 2, id: 't2' },
          { value: '...', id: 't3', jumpNext: false },
          { value: activePage - 1, id: 't4' },
          { value: activePage, id: 't5' },
        ];
    }
  };
  const createPaginationArr = useMemo(() => {
    if (totalPageCount <= 5) {
      return new Array(totalPageCount).fill('').map((el: string, index: number) => ({
        value: index + 1,
        id: `t${index + 1}`,
      }));
    }
    if (totalPageCount > 5) {
      return switchToCorrectPaginationArr();
    }
  }, [activePage, totalPageCount]);

  const countPageToJumpForward = () => {
    const canIJumpForward = activePage + 3 <= totalPageCount;
    if (canIJumpForward) {
      return activePage + 3;
    }
    return totalPageCount;
  };

  const countPageToJumpPrevious = () => {
    const canIJumpPrev = activePage - 3 > 0;
    if (canIJumpPrev) {
      return activePage - 3;
    }
    return 1;
  };

  return { createPaginationArr, countPageToJumpPrevious, countPageToJumpForward };
};
